import React from 'react'
import { Link, useLocation } from "react-router-dom";

export default function Subheader({subheadData}) {
    const location = useLocation();
    const BranchName = location.pathname?.split("/")[1];

    const h1Pages = [
        "/blog",
        "/news",
        "/manager-desk",
        "/director-desk",
        "/learning-pathway-foundation",
        `/${BranchName}/manager-desk`,
        `/${BranchName}/director-desk`,
        `/${BranchName}/principal-desk`,
    ]

    const isHeadingPage =
    h1Pages.includes(location.pathname) ||
    location.pathname.endsWith("/manager-desk");

  return (
    <>
    <div className="subheader" style={{backgroundImage: `url(${subheadData.image})`}}>
        <div className="container">
            <div className="row">  
                <div className="col-lg-12">
                    {isHeadingPage ? (
                        <h1 className="submain-head">{subheadData.pagename}</h1>
                        ) : (
                        <p className="submain-head">{subheadData.pagename}</p>
                    )}
                    <ul>
                        <li><Link to={"/"}>Home</Link></li>
                        {subheadData.category && subheadData.categoryLink && (
                            <li>
                                <Link to={`/${BranchName}${subheadData.categoryLink}`}>
                                {subheadData.category}
                                </Link>
                            </li>
                        )}
                        {subheadData.nextItem && <li>{subheadData.nextItem} </li>}
                        {subheadData.pagename && <li>{subheadData.pagename} </li>}
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
